import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { Product } from '../types/product.type';
import { CreateProductRequestDTO } from '../types/dtos/create-product.dto';
import { ADMIN_PRODUCTS_API_PATHS } from '../constants/products-api-paths.constants';

type UseCreateProductResult = {
  createProduct: (data: CreateProductRequestDTO) => Promise<Product | null>;
  isSubmitting: boolean;
};

export function useCreateProduct(): UseCreateProductResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const createProduct = async (data: CreateProductRequestDTO): Promise<Product | null> => {
    setIsSubmitting(true);

    try {
      const product = await HttpClient.post<Product, CreateProductRequestDTO>(
        ADMIN_PRODUCTS_API_PATHS.CREATE_PRODUCT,
        data
      );

      enqueueSnackbar('Le produit a été créé', { variant: 'success' });
      return product;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, 'Une erreur est survenue lors de la création du produit'),
        {
          variant: 'error',
        }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { createProduct, isSubmitting };
}
